var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44922 23.45V20.59",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.82H22.5V20.59H1.5V15.82Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51922 11H17.5192C18.5987 11 19.6339 11.4288 20.3971 12.1921C21.1604 12.9553 21.5892 13.9906 21.5892 15.07V15.77H2.44922V15.07C2.44922 13.9906 2.87802 12.9553 3.64129 12.1921C4.40457 11.4288 5.43979 11 6.51922 11Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22937 7.23H9.13938C9.51496 7.23 9.88686 7.30397 10.2338 7.4477C10.5808 7.59143 10.8961 7.8021 11.1617 8.06767C11.4273 8.33325 11.6379 8.64853 11.7817 8.99552C11.9254 9.34251 11.9994 9.71442 11.9994 10.09V11.09H4.35938V10.09C4.35937 9.71357 4.43368 9.34085 4.57803 8.99321C4.72239 8.64556 4.93395 8.32984 5.20058 8.06413C5.46722 7.79842 5.78368 7.58796 6.13183 7.44483C6.47998 7.30169 6.85295 7.22868 7.22937 7.23Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 7.22998H16.77C17.5285 7.22998 18.256 7.5313 18.7923 8.06766C19.3287 8.60401 19.63 9.33146 19.63 10.09V11.09H12V10.09C12 9.33146 12.3013 8.60401 12.8377 8.06766C13.374 7.5313 14.1015 7.22998 14.86 7.22998Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 3.40997H19.6294V11.05H4.35938V3.40997Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 23.45V20.59",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 0.549988V3.40999",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6406 0.549988V3.40999",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.0415c217.svg";
export { ForwardRef as ReactComponent };